import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { TruckRepository } from "../../../../data/repository/truck/TruckRepository";
import { AccessToken, Auth } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";
import {
  FilterTrucksByModel,
  GenerateXmlFileResponse,
  Truck,
} from "../../../model/Truck";

export interface GenerateXmlFileUseCase {
  invoke: (
    model?: FilterTrucksByModel,
    ids?: Array<string>
  ) => Promise<ResponseState<GenerateXmlFileResponse>>;
}

export class GenerateXmlFileUseCaseImpl implements GenerateXmlFileUseCase {
  private repo: TruckRepository;

  constructor(repo: TruckRepository) {
    this.repo = repo;
  }

  async invoke(
    model?: FilterTrucksByModel,
    ids?: Array<string>
  ): Promise<ResponseState<GenerateXmlFileResponse>> {
    try {
      let response = await this.repo.generateXmlFile(model, ids);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
